import VirtualEventRenderer from './components/VirtualEventRenderer';

export default VirtualEventRenderer;
